<template>
  <el-dialog title="Order Export" :visible.sync="visible" width="450">
    <el-form :model="form" label-width="100px">
      <el-form-item label="Status">
        <el-select v-model="form.statusArr" multiple placeholder="Status" clearable>
          <el-option v-for="s in statusList" :key="s.status" :value="s.status" :label="s.cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="Time Range">
        <el-date-picker
          v-model="form.timeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="-"
          start-placeholder="Begin time"
          end-placeholder="End time"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="exportExcel">Export</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  data() {
    return {
      visible: false,
      statusList: [],
      form: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "Yesterday",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              start.setHours(23);
              start.setMinutes(0);
              start.setSeconds(0);

              const end = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              end.setHours(23);
              end.setMinutes(0);
              end.setSeconds(0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    async show() {
      this.form = {};
      this.visible = true;
      await this.loadStatusList();
    },
    async loadStatusList() {
      this.statusList = await this.axios.get("mall:/api/admin/buyer-order/statusList");
    },
    exportExcel() {
      let url =
        process.env.VUE_APP_MALL_API +
        "/api/admin/buyer-order/exportExcel?timestamp=" +
        new Date().getTime() +
        "&userToken=" +
        getToken();
      if (this.form.timeRange && this.form.timeRange.length === 2) {
        url += "&dateFrom=" + encodeURI(this.form.timeRange[0] + "");
        url += "&dateTo=" + encodeURI(this.form.timeRange[1] + "");
      } else {
        this.$message.error("Please select time range");
        return;
      }
      if (this.form.statusArr && this.form.statusArr.length) {
        url += "&statusList=" + this.form.statusArr.join(",");
      }

      this.visible = false;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped></style>
